import React, { useState, useEffect } from "react";
import config from "../../../config/domain";
import { NavLink, Link } from "react-router-dom";
import { RoutesUrl } from "../../Routes/constents";
import { getTolocalStorage } from "../../Constants/commenFeatures";
import LoginService from "../../../services/login/loginService";

const HeaderAuth = ({ logout, isNavbar, showNavbar }) => {
  const [isVendor, setIsVendor] = useState();
  const [etotpEnabled, setEtotpEnabled] = useState(false);

  useEffect(() => {
    async function checkVandorAuth() {
      const isVAndor = await getTolocalStorage("loginAs");
      if (isVAndor === "vendor") {
        setIsVendor(true);
      } else {
        setIsVendor(false);
      }
      const etotpFlow = LoginService.getAccData("accs").etotpSwitch;
      setEtotpEnabled(etotpFlow);
    }
    checkVandorAuth();
  }, []);

  return (
    <div className="navbar-menu">
      <div className={isNavbar ? "mobileView " : "hide_nav"}>
        <div>
          <ul onClick={showNavbar}>
            {isVendor ? (
              <>
                <li>
                  <NavLink
                    exact
                    activeClassName="active"
                    to={RoutesUrl.VendorDashboard}
                  >
                    DashBoard
                  </NavLink>
                </li>
                <li className="active">
                  <NavLink
                    exact
                    activeClassName="active"
                    to={RoutesUrl.VendorMyApps}
                  >
                    My Apps
                  </NavLink>
                </li>
              </>
            ) : (
              <li className="active">
                <NavLink exact activeClassName="active" to={RoutesUrl.MyApps}>
                  My Apps
                </NavLink>
              </li>
            )}
            {etotpEnabled && (<li>
              <NavLink exact activeClassName="active" to={RoutesUrl.Etotp}>
                TOTP
              </NavLink>
            </li>)}
            <li className="nav-sub-container">
              <a href="javascript:void(0)">Documentation</a>
              <ul className="nav-sublink">
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={config.jmw_client_docs}
                  >
                    Client Documentation
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={config.jmw_partner_docs}
                  >
                    Partner Documentation
                  </a>
                </li>
                {/* {isVendor ? (
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={config.jmw_order_trade_docs}
                    >
                      Order/Trade Update Streaming
                    </a>
                  </li>
                ) : null} */}
              </ul>
            </li>
            <li>
              <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
                Resources
              </NavLink>
            </li>
            <li>
              <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
                Support
              </NavLink>
            </li>
            <li onClick={logout}>
              <NavLink to="#">
                {" "}
                <i className="edel-icon-logout"></i> Logout
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      <ul className="destopView">
        {isVendor ? (
          <>
            <li>
              <NavLink
                exact
                activeClassName="active"
                to={RoutesUrl.VendorDashboard}
              >
                Dashboard
              </NavLink>
            </li>
            <li className="active">
              <NavLink
                exact
                activeClassName="active"
                to={RoutesUrl.VendorMyApps}
              >
                My Apps
              </NavLink>
            </li>
          </>
        ) : (
          <li className="active">
            <NavLink exact activeClassName="active" to={RoutesUrl.MyApps}>
              My Apps
            </NavLink>
          </li>
        )}
        {etotpEnabled && (<li>
          <NavLink exact activeClassName="active" to={RoutesUrl.Etotp}>
            TOTP
          </NavLink>
        </li>)}
        <li className="nav-sub-container">
          <a href="javascript:void(0)">Documentation</a>
          <ul className="nav-sublink">
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href={config.jmw_client_docs}
                onClick={() => window.open(config.jmw_client_docs)}
              >
                Client Documentation
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href={config.jmw_partner_docs}
                onClick={() => window.open(config.jmw_partner_docs)}
              >
                Partner Documentation
              </a>
            </li>
            {/* {isVendor ? (
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={config.jmw_order_trade_docs}
                >
                  Order/Trade Update Streaming
                </a>
              </li>
            ) : null} */}
          </ul>
        </li>
        <li>
          <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
            Resources
          </NavLink>
        </li>
        <li>
          <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
            Support
          </NavLink>
        </li>
        <li onClick={logout}>
          <Link to="#">
            <i className="edel-icon-logout"></i>
            Logout
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default HeaderAuth;
